import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const NotFound = () => {

    const navigate = useNavigate();
    let token = localStorage.getItem("AUTH_TOKEN");


    useEffect(() => {
        token ? navigate('/products') : navigate('/login');
    }, [token]);

    return (
        <div >
             
        </div>

    )
}

export default NotFound;